/** Full-screen loading state shown during initial auth session check.
 *  Shows cached agency branding from the previous visit if available,
 *  otherwise falls back to the AGNT X default icon. */
export function LoadingScreen() {
  let logoUrl: string | null = null
  let agencyName: string | null = null
  try {
    const raw = localStorage.getItem('fx-portal-brand')
    if (raw) {
      const parsed = JSON.parse(raw) as { logoUrl?: string; name?: string }
      logoUrl    = parsed.logoUrl ?? null
      agencyName = parsed.name ?? null
    }
  } catch { /* ignore */ }

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-5 bg-[var(--sidebar-bg)]">
      {logoUrl ? (
        <div className="relative w-16 h-16">
          <img src={logoUrl} alt={agencyName ?? 'Agency'} className="w-16 h-16 rounded-2xl object-contain" />
          <span className="absolute inset-0 rounded-2xl animate-ping bg-white/5" />
        </div>
      ) : (
        <div className="relative">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <span className="absolute inset-0 rounded-2xl animate-ping bg-indigo-500/20" />
        </div>
      )}

      {agencyName && (
        <p className="text-sm font-semibold text-[var(--sidebar-text)]">{agencyName}</p>
      )}

      <div className="w-48 space-y-2 mt-2">
        <div className="h-2 rounded-full bg-white/10 animate-pulse" />
        <div className="h-2 rounded-full bg-white/[0.07] animate-pulse w-3/4 mx-auto" />
      </div>
    </div>
  )
}
